import Vue from "vue";
import app from "@/main";

async function deleteData( loadingName, url ) {
	if ( loadingName ) {
		app.$wait.start( loadingName );
	}

	try {
		return ( await Vue.axios.delete( url ) ).data;
	} finally {
		if ( loadingName ) {
			app.$wait.end( loadingName );
		}
	}
}

export const deleteDriverTimeOff = ( idDriver, idTimeOff ) => deleteData( "deleteDriverTimeOff", `yard/drivers/${idDriver}/time-off/${idTimeOff}` );
